import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  roomsTableSearchParamKeys,
  searchParamKeys,
} from '../../../../shared/configs/searchParams';
import { useCurrentAcceptance } from '../../../../services/queries/acceptanceData';
import { paths } from '../../../../shared/configs/routing';

const acceptanceKey = searchParamKeys.acceptance;

const ToSetRoomsFromDatePage = () => {
  const history = useHistory();
  const acceptance = useCurrentAcceptance();

  const handleClick = () => {
    const { push, location } = history;

    const searchParams = new URLSearchParams(location.search);

    const newParams = roomsTableSearchParamKeys.reduce((acc, key) => {
      const value = searchParams.get(key);

      if (value) {
        acc[key] = value;
      }

      return acc;
    }, {});

    newParams[acceptanceKey] = searchParams.get(acceptanceKey);

    push({
      pathname: paths.setRoomsFromDate,
      search: new URLSearchParams(newParams).toString(),
      state: { from: { location, acceptance } },
    });
  };

  return (
    <div onClick={handleClick}>
      Установить/Очистить период записи на приемку для определенных помещений
    </div>
  );
};

export default ToSetRoomsFromDatePage;
